export default __webpack_public_path__ + "static/media/burn.367bd726.png";